// extracted by mini-css-extract-plugin
export var pillWrapper = "_mg-0";
export var showOverflow = "_mg-1";